module.exports = __webpack_public_path__ + "img/v2.4.ea9fec14.png";